import { render, staticRenderFns } from "./FeaturesReminder.vue?vue&type=template&id=4a369862&"
import script from "./FeaturesReminder.vue?vue&type=script&lang=js&"
export * from "./FeaturesReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports